import React from "react";
import "../../styles/glow-edge.css";

/**
 * GlowEdge
 *
 * Renders a subtle cyan/ice-blue glow along one edge using a ::before pseudo-element.
 * Supports horizontal (top/bottom) and vertical (left/right) edges.
 */
export default function GlowEdge({
  side = "top", // "top" | "bottom" | "left" | "right"
  thickness = 2,
  className = "",
  style = {},
  children,
}) {
  const resolvedThickness = typeof thickness === "number" ? `${thickness}px` : thickness;

  const mergedStyle = {
    ...style,
    ["--up-glow-thickness"]: resolvedThickness ?? "2px",
  };

  const sideClass =
    side === "bottom"
      ? "up-glow-edge--bottom"
      : side === "left"
        ? "up-glow-edge--left"
        : side === "right"
          ? "up-glow-edge--right"
          : "up-glow-edge--top";

  return (
    <div className={["up-glow-edge", sideClass, className].filter(Boolean).join(" ")} style={mergedStyle}>
      {children}
    </div>
  );
}


